// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format4 } from '../../constants';

/** Mayotte */
const YT: PhoneNumberData = [
  262,
  'YT',
  9,
  format4,
  /^(?:(?:639(?:0[0-79]|1[019]|[267]|3[09]|40|5[05-9]|9[04-79])|7093[5-7]))/,
];

export default YT;
